import * as c from "react";
const e = (a) => /* @__PURE__ */ c.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ c.createElement(
    "path",
    {
      d: "M21.899 20.387l-2.084-2.245a.405.405 0 00-.14-.099.448.448 0 00-.176-.035H4.5c-.06 0-.12.012-.175.035a.406.406 0 00-.142.1l-2.083 2.244a.32.32 0 00-.058.397.38.38 0 00.152.159.442.442 0 00.223.058h19.164c.08 0 .157-.02.223-.058a.38.38 0 00.152-.159.321.321 0 00-.058-.396zM7.417 10.896h-2.5c-.23 0-.416.168-.416.375v5.612c0 .207.187.374.417.374h2.5c.23 0 .416-.167.416-.374v-5.612c0-.207-.186-.375-.417-.375zM13.25 10.896h-2.5c-.23 0-.417.168-.417.375v5.612c0 .207.187.374.417.374h2.5c.23 0 .416-.167.416-.374v-5.612c0-.207-.186-.375-.417-.375zM19.082 10.896h-2.5c-.23 0-.416.168-.416.375v5.612c0 .207.187.374.417.374h2.5c.23 0 .416-.167.416-.374v-5.612c0-.207-.186-.375-.416-.375zM3.734 9.984c.04.05.092.092.153.12a.465.465 0 00.197.044h15.831a.464.464 0 00.198-.043.414.414 0 00.152-.121l.833-1.123a.344.344 0 00.022-.387.396.396 0 00-.155-.145.453.453 0 00-.216-.052H3.25a.453.453 0 00-.216.052.396.396 0 00-.156.145.343.343 0 00.022.387l.833 1.123zM3.251 7.529H20.75c.11.02.225.001.32-.054a.384.384 0 00.184-.242.35.35 0 00-.06-.287.43.43 0 00-.27-.165l-8.748-3.742a.41.41 0 00-.35 0L3.076 6.78a.43.43 0 00-.269.165.35.35 0 00-.06.287c.023.1.09.187.184.242.095.055.21.075.32.054z",
      fill: "#2d6ded"
    }
  )
), t = e;
export {
  t as default
};
